import React from 'react'
import clsx from 'clsx'
import {Tooltip} from '../Tooltip/index.ts'
import {type TranslationObject} from '@colonist/i18n'
import styles from './LocationFlag.module.scss'
import {getCountryOrContinentImageLink, getTooltipText} from './utils.ts'
import {T} from '../T/index.ts'
import {type ContinentCode, type CountryCode} from '@colonist/types'
import {type Placement} from '@floating-ui/dom'

export interface Location {
    countryCode?: CountryCode | undefined
    continentCode?: ContinentCode | undefined
}

export interface LocationFlagProps {
    className?: string
    location: Location
    tooltipPosition?: Placement
    customTooltipText?: TranslationObject
    onClick?: () => void | undefined
    isUserOnDiscord?: boolean // TODO: @Dang Remove this prop once we replace twemoji with flag images in our codebase
}

export const LocationFlag = ({
    className,
    location,
    tooltipPosition = 'top',
    customTooltipText,
    onClick,
    isUserOnDiscord = false,
}: LocationFlagProps) => {
    const {countryCode, continentCode} = location

    return <Tooltip
        delay={0}
        centerText
        position={tooltipPosition}
        content={<T id={customTooltipText ?? getTooltipText(countryCode, continentCode)}/>}>
        <img
            onClick={onClick}
            className={clsx(styles.flag,
                {[styles.clickable]: onClick != undefined},
                className)}
            src={getCountryOrContinentImageLink(countryCode, continentCode, isUserOnDiscord)}
            alt={countryCode ?? continentCode ?? ''}
        />
    </Tooltip>
}
